import React from "react";
import { Link } from "react-router-dom";
import { SERVICES, MARKET_RATES } from "../data/services";
import { trackItemSelect } from "../utils/analytics";
import "../components/styles/PricingPage.css";

// 개발 비용 페이지.
//
// `챗봇 구축 비용`, `LLM 도입 비용`, `플랫폼 개발 비용` 같은 검색이 많은데
// 외주 업체 대부분이 "케이스마다 다릅니다, 문의주세요" 만 써 둬서 그 검색
// 결과가 비어 있다. 숫자를 적은 페이지가 거의 없다는 뜻이다.
//
// 여기 적는 금액은 우리가 부른 값이 아니라 공개된 시장 실거래 범위다.
// 출처를 밝히고 쓴다. 담당자는 내부 보고에 쓸 근거를 찾는 것이라
// 정확한 한 숫자보다 출처 있는 범위가 쓸모 있다.

const PricingPage = () => (
    <div className="sch-price">
        <div className="sch-wrap sch-price__inner">

            <h1 className="sc-h2">개발 비용</h1>
            <p className="sch-price__lede">
                "케이스마다 다릅니다" 는 맞는 말이지만 아무 도움이 안 됩니다.
                그래서 공개된 시장 실거래 범위를 그대로 적습니다. 정확한 견적은
                기능 수를 세어 봐야 나오지만, 규모를 가늠하는 데는 충분합니다.
            </p>

            {/* 우리 분야부터. 시장 표는 그다음이다 */}
            <section className="sch-price__sec">
                <h2 className="sc-h3">분야별 범위</h2>
                <div className="sc-tablewrap">
                    <table className="sc-table sch-price__table">
                        <thead>
                        <tr>
                            <th>분야</th>
                            <th>비용</th>
                            <th>기간</th>
                        </tr>
                        </thead>
                        <tbody>
                        {SERVICES.map((s) => (
                            <tr key={s.slug}>
                                <td>
                                    <Link
                                        to={`/service/${s.slug}`}
                                        onClick={() => trackItemSelect(`pricing:${s.slug}`)}
                                    >
                                        {s.nav}
                                    </Link>
                                </td>
                                <td className="sch-price__num">{s.price.range}</td>
                                <td>{s.price.period}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <p className="sch-price__note">
                    분야를 누르면 그 일을 어떻게 하는지와 실제 수행 사례가 나옵니다.
                </p>
            </section>

            <section className="sch-price__sec">
                <h2 className="sc-h3">무엇이 금액을 움직이나</h2>
                <p>
                    같은 분야라도 두세 배가 갈립니다. 갈리는 지점은 대개 정해져 있습니다.
                </p>
                <dl className="sch-price__factors">
                    <div>
                        <dt>연동할 시스템이 API 를 열어뒀는지</dt>
                        <dd>
                            열려 있으면 붙이면 되고, 아니면 화면을 조작해야 합니다.
                            국내 업무 시스템은 안 열려 있는 쪽이 더 많습니다.
                        </dd>
                    </div>
                    <div>
                        <dt>데이터가 정리돼 있는지</dt>
                        <dd>
                            AI 쪽은 특히 그렇습니다. 흩어진 문서를 모아 정리하는 공수가
                            모델을 붙이는 공수보다 큰 경우가 흔합니다.
                        </dd>
                    </div>
                    <div>
                        <dt>예외가 몇 가지인지</dt>
                        <dd>
                            "보통은 이런데 이럴 땐 이렇게 해요" 가 몇 개냐가 실제 공수입니다.
                            기본 흐름 하나는 금방 만들고, 예외가 열 개면 거기서 한 달이 갑니다.
                        </dd>
                    </div>
                    <div>
                        <dt>누가 운영할지</dt>
                        <dd>
                            담당자가 직접 설정을 바꿀 수 있어야 하면 관리 화면이 붙습니다.
                            견적에서 자주 빠지는데, 빼면 운영이 안 돼서 나중에 더 듭니다.
                        </dd>
                    </div>
                </dl>
            </section>

            <section className="sch-price__sec">
                <h2 className="sc-h3">시장 시세 — 유형별</h2>
                <p>
                    아래는 저희 금액이 아니라 공개된 시장 실거래 범위입니다.
                    받으신 견적이 터무니없는지 아닌지 재보시는 데 쓰시면 됩니다.
                </p>
                <div className="sc-tablewrap">
                    <table className="sc-table sch-price__table">
                        <thead>
                        <tr>
                            <th>유형</th>
                            <th>비용</th>
                        </tr>
                        </thead>
                        <tbody>
                        {MARKET_RATES.rows.map((r) => (
                            <tr key={r.type}>
                                <td>{r.type}</td>
                                <td className="sch-price__num">{r.range}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <p className="sch-price__src">
                    출처: {MARKET_RATES.source} ·{" "}
                    <a href={MARKET_RATES.sourceUrl} target="_blank" rel="noopener noreferrer nofollow">
                        원문 ↗
                    </a>
                </p>
            </section>

            <section className="sch-price__sec">
                <h2 className="sc-h3">시장 시세 — 챗봇</h2>
                <p>{MARKET_RATES.chatbot.avg}</p>
                <div className="sc-tablewrap">
                    <table className="sc-table sch-price__table">
                        <thead>
                        <tr>
                            <th>유형</th>
                            <th>비용</th>
                            <th>기간</th>
                        </tr>
                        </thead>
                        <tbody>
                        {MARKET_RATES.chatbot.rows.map((r) => (
                            <tr key={r.type}>
                                <td>{r.type}</td>
                                <td className="sch-price__num">{r.range}</td>
                                <td>{r.period}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <p className="sch-price__src">
                    출처: {MARKET_RATES.chatbot.source} ·{" "}
                    <a href={MARKET_RATES.chatbot.sourceUrl} target="_blank" rel="noopener noreferrer nofollow">
                        원문 ↗
                    </a>
                </p>
            </section>

            <section className="sch-price__sec">
                <h2 className="sc-h3">견적 받으실 때 확인하실 것</h2>
                <ul className="sch-price__list">
                    <li>
                        <b>일괄 금액만 적힌 견적은 비교가 안 됩니다.</b> 기능별로 나눠 달라고
                        하세요. 어디가 비싼지 보여야 뺄 것을 뺄 수 있습니다.
                    </li>
                    <li>
                        <b>유지보수 범위가 어디까지인지.</b> 버그 수정만인지, 기능 추가도
                        포함인지, 몇 개월인지.
                    </li>
                    <li>
                        <b>소스를 주는지.</b> 안 주는 곳도 있습니다. 나중에 다른 데
                        맡기려면 막힙니다.
                    </li>
                    <li>
                        <b>서버 비용이 포함인지 별도인지.</b> AI 쪽은 쓰는 만큼 나가서
                        월 비용이 따로 붙습니다.
                    </li>
                </ul>
                <p className="sch-price__note">
                    저희한테 안 맡기셔도 그대로 쓰시면 됩니다.
                </p>
            </section>

            <section className="sch-price__end">
                <h2 className="sc-h3">얼마인지 먼저 알려드립니다</h2>
                <p>
                    어떤 일을 자동화하고 싶으신지만 적어주시면 영업일 1~2일 안에
                    범위와 금액을 드립니다. 상담과 견적은 무료이고, 맡기지 않으셔도 됩니다.
                    법에 저촉되거나 상대 서비스 약관을 어기는 건은 받지 않습니다.
                </p>
                <Link
                    to="/custom-product-second"
                    className="sc-btn"
                    onClick={() => trackItemSelect("pricing-end")}
                >
                    견적 받기
                </Link>
            </section>

        </div>
    </div>
);

export default PricingPage;
